module.exports = __webpack_public_path__ + "media/images/anonymous-b17e713ccf66e3c1b0e505a64313bb05.png";